import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import firebase from 'firebase';
import ModalPerfiles from './ModalPerfiles';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';
import {sendLog} from '../../util'

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};



class Perfiles extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			perfiles:[],
			accesos:[],
			accesostemp:[],
			paginas:[],
			paginasEliminadas:[],
			paginasAgregadas:[],
			isActive:false,
			nombrePagina:'',
			url:'',
			nombrePerfil:'',
			keyPerfil:'',
			template:false
		}
		
		this.perfilesRef=database.ref().child('Perfiles');
		this.accesosRef=database.ref().child('Accesos');
		this.paginasRef=database.ref().child('Paginas');
	
		this.handleClickEditar=this.handleClickEditar.bind(this);
		this.handleClickEliminarPagina=this.handleClickEliminarPagina.bind(this);
		this.toggleModal=this.toggleModal.bind(this);
		this.handleChange=this.handleChange.bind(this);
		this.updateRow=this.updateRow.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		
		//Función para crear los options del select de paginas o en este caso Accesos
		this.MakeItemsPaginas=this.MakeItemsPaginas.bind(this);
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
		
	}
	
	
	
	
	handleClickAlerta(event){
		
		this.setState({
			template:true
		
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  preserveContext: true,
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
  
  
	handleClickClose(){		
		Alert.closeAll();
	}
	
	componentDidMount(){
		
		this.perfilesRef.on('value',this.gotData,this.errData);
		this.paginasRef.on('value',this.gotDataPaginas,this.errDataPaginas);
	}
	
	
	gotData=(data)=>{
		
		let newPerfil=[];
		
		const perfilesdata=data.val();
		
		//Si el nodo de perfiles no esta vacio
		if(perfilesdata!=null){
			
			const keys = Object.keys(perfilesdata);
			
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newPerfil.push({
					key:k,
					nombre:perfilesdata[k].nombre				  
				});				
			}
			 this.setState({perfiles: newPerfil});			
		}		
	}
	errData=(err)=>{		
		console.log(err)
	}
	
	
	updateRow(){
		

		let nombrePerfil=this.nombrePerfil1.value;
		
		
		
		let keyPerfil=this.state.keyPerfil;
		
		
		if(this.state.accesos.length===0){
			
			Alert.error('Debes selecionar almenos un acceso para crear este perfil', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000
						
			});
		}
		else{
				
			this.perfilesRef.child(keyPerfil).update({			
				nombre:nombrePerfil
			})
	
			
	
			if(this.state.paginasEliminadas.length!=0){
				
				for(let i=0;i<this.state.paginasEliminadas.length;i++){
				
					database.ref().child('Accesos').child(keyPerfil).child(this.state.paginasEliminadas[i].key).remove();
				
				}	
				
			}			
			if(this.state.paginasAgregadas.length!=0){
				
				for(let i=0;i<this.state.paginasAgregadas.length;i++){
				
					
				
					let nombrePagina=this.state.paginasAgregadas[i].nombre;
					let urlPagina=this.state.paginasAgregadas[i].url;
					let iconClass=this.state.paginasAgregadas[i].iconClass;
				
					
					database.ref().child('Accesos').child(keyPerfil).orderByChild('nombre').equalTo(this.state.paginasAgregadas[i].nombre).once("value").then(snapshot=>{
					
						if(!snapshot.exists()){
							database.ref().child('Accesos').child(keyPerfil).push({
							nombre:nombrePagina,
							url:urlPagina,
							iconClass
						
							});
					
						}
					
					});
					
					
				}	
				
			}	
			sendLog({ tipo: 'perfil_editado', informacion_extra: {perfil: keyPerfil} });
			Alert.success('Datos actualizados con exito', {				
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000
						
			});
			
			this.toggleModal();
			
		}
		
		
		
	}
	
	
	gotDataPaginas = (data) => {
		
		  let newPagina=[];
		  const paginasdata = data.val();
		  //Si el nodo de paginas no esta vacio (que no deberia de estarlo)
		  if(paginasdata!=null){
			  
			  const keys = Object.keys(paginasdata);
			
			  for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newPagina.push({
					key:k,
					nombre:paginasdata[k].nombre,
					url:paginasdata[k].url,
					iconClass:paginasdata[k].iconClass
				});
			  }
			 this.setState({paginas:newPagina});
			  
		  }
		
		}
		errDataPaginas = (err) => {
	  console.log(err);
	}
	
	
	handleChange(){
		
		
		let paginaBuscada=this.state.accesos.find(pagina => pagina.nombre===this.accesosPerfil.value);
		
		if(paginaBuscada===undefined){
			
			let pagina=this.state.paginas.find(pagina=> pagina.nombre===this.accesosPerfil.value);
			
			this.state.accesos.push({
				key:pagina.key,
				nombre:pagina.nombre,
				url:pagina.url,
				iconClass:pagina.iconClass
			});
			
			this.state.paginasAgregadas.push({
				key:pagina.key,
				nombre:pagina.nombre,
				url:pagina.url,
				iconClass:pagina.iconClass
			});
			
			this.setState({
				paginasEliminadas:this.state.paginasEliminadas.filter(pagina=>pagina.nombre!=this.accesosPerfil.value),
				accesostemp:this.state.accesostemp.filter(pagina=>pagina.nombre!=this.accesosPerfil.value)
			});		
				
		}
		
	
	
	}
	
	
	//Retorna las opciones para llenar el select de los perfiles
	MakeItemsPaginas(x){
		return <option key={x.key} >{x.nombre}</option>;		
	}

	btnVerFormatter(cell, row) {

		return <button type="button" className="btn btn-success btn-sm" onClick={() => { this.handleClickEditar(row) }}>Editar accesos</button>;
	}
	
	handleClickEditar(row){
		
		this.toggleModal();
		
		let keyPerfil=row.key;
		
		this.setState({
			 nombrePerfil:row.nombre,
			 keyPerfil:row.key
		});			
		
		this.accesosRef.child(keyPerfil).on("value",(snapshot)=> {
				
	
				
				let dataaccesos=snapshot.val();
				let newAcceso=[];
				if(dataaccesos!=null){
			
					const keys = Object.keys(dataaccesos);
			
					for (let i = 0; i < keys.length; i++) {
						const k = keys[i];
						
						newAcceso.push({
							key:k,
							nombre:dataaccesos[k].nombre,
							url:dataaccesos[k].url
						});				
					}
					this.setState({
						 accesos: newAcceso,
						 accesostemp:newAcceso
					});			
				}		
				
				
		}, function (errorObject) {
			console.log("The read failed: " + errorObject.code);
		});
	
	}
	
	toggleModal(){
		
		this.setState({			
			isActive:!this.state.isActive,
			accesos:[],
			accesostemp:[],
			paginasAgregadas:[],
			paginasEliminadas:[]
		});
		
	}
	
	btnEliminarFormatter(cell, row) {
		return (
			<button className="btn btn-danger btn-sm" onClick={() => { this.handleClickEliminarPagina(row) }}>
				Eliminar
			</button>
		);
	}
	
	
	handleClickEliminarPagina(row){		
	
		this.state.paginasEliminadas.push({			
			key:row.key,
			nombre:row.nombre,
			url:row.url			
		});
	
		
		this.setState({
			accesos:this.state.accesos.filter(paginas=>paginas.nombre!=row.nombre)
		});	
	}
	
	btnEliminarFormatter(cell, row) {
		return (
			<button className="btn btn-danger btn-sm" onClick={() => { this.handleClickEliminarPagina(row) }}>
				Eliminar
			</button>
		);
	}

	handleClickEliminarPagina(row) {
		this.state.paginasEliminadas.push({
			key: row.key,
			nombre: row.nombre,
			url: row.url
		});

		this.setState({
			accesos: this.state.accesos.filter(paginas => paginas.nombre != row.nombre)
		});
	}

	ocultarMenu() {
		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	render(){
		
		return(
			
			<div className="Perfiles container" onClick={this.ocultarMenu}>
					{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} stack={false} offset={200}/>:<Alert stack={false} html={true} />}
					
				<ModalPerfiles />

				<BootstrapTable data={this.state.perfiles}
					ref='table'
					pagination={true}
					search={true} searchPlaceholder="Buscar"
					hover
				>
					<TableHeaderColumn dataField='key' isKey={true} dataSort={true} dataAlign='center' hidden >Nombre</TableHeaderColumn>
					<TableHeaderColumn dataField='nombre' dataSort={true}>Perfil</TableHeaderColumn>
					<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.btnVerFormatter.bind(this)}>Accesos</TableHeaderColumn>

				</BootstrapTable>

				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal} style={customStyles}>
						
					<h4>Editar Perfil</h4>
					<hr/>
					
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
						
							<div className="form-group">
								<label htmlFor="nombre_perfil">Nombre del perfil</label>
								<input type="text" required name="nombre_perfil" autoComplete="off" placeholder="Nombre del perfil"
								className="form-control"
								defaultValue={this.state.nombrePerfil}
								ref={input => {this.nombrePerfil1=input;}}
								/>
							</div>

						<div className="form-group">
							<label htmlFor="">Accesos </label>
							<select className="form-control"
								ref={input => { this.accesosPerfil = input; }}
								onChange={this.handleChange} defaultValue=" "
								>
									{this.state.paginas.map(this.MakeItemsPaginas)}
								</select>								
							</div>
							
							<div className="tabla-registros">
							<BootstrapTable data={ this.state.accesos}
								 ref='table'
								 pagination={ false }
								 search={ false }
								 hover
								 >
								<TableHeaderColumn dataField='key' isKey={true} dataSort={true} dataAlign='center' hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn dataField='nombre' dataSort={true}>Nombre de la página</TableHeaderColumn>
								<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.btnEliminarFormatter.bind(this)}>Eliminar</TableHeaderColumn>
							</BootstrapTable>
						</div>

						<hr />

						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					</form>
					<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>

				</Modal>
				<footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div className="container">
					<div className="row">
						<div className="col-md-4 col-sm-4">
						</div>
						<div className="col-sm">
						<img src={copyright} />
						</div>
					</div>
					</div>
				</footer>
			</div>
			
			
	
	
		);	
	}	
}

export default Perfiles;



// WEBPACK FOOTER //
// ./src/Components/Perfiles/Perfiles.js